
import { getApiVersion } from './config.js'
import { makeGetRequest, makePostRequest } from './util.js'

const RELATIVE_PREFIX = 'user_management'

function statusManagementApiToken() {
  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/management_api_token`)
}

function refreshManagementApiToken() {
  return makePostRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/management_api_token`)
}

function getUsers(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.perPage) filteredQueryParams.per_page = queryParams.perPage
  if (queryParams?.page) filteredQueryParams.page = queryParams.page
  if (queryParams?.search) filteredQueryParams.search = queryParams.search
  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/user`, filteredQueryParams)
}

function getUserGroups() {
  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/user_group`)
}

function getPortalUsers(data) {
  return makePostRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/portal_user`, data)
}

function getConfigContent(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.type) filteredQueryParams.type = queryParams.type
  if (queryParams?.schoolYear) filteredQueryParams.school_year = queryParams.schoolYear
  if (queryParams?.districtCode) filteredQueryParams.district_code = queryParams.districtCode
  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/config_content`, filteredQueryParams)
}

function batchManageUsersCommands(data) {
  return makePostRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/batch_manage_users_commands`, data)
}

export {
  statusManagementApiToken,
  refreshManagementApiToken,
  getUsers,
  getUserGroups,
  getPortalUsers,
  getConfigContent,
  batchManageUsersCommands,
}
